/**
 * Text Block Slice
 *
 * Text block with heading, subheading, and content.
 */

import React from "react";
import { graphql } from "gatsby";
import { motion } from "framer-motion";
import { isFilled } from "@prismicio/client";
import { PrismicRichText } from "@prismicio/react";
import * as styles from "./TextBlock.module.scss";

export const TextBlock = ({ slice }) => {
  const { heading, subheading, text_content, color_scheme, include_divider } = slice?.primary || {};

  return (
    <section data-color-scheme={color_scheme || "white"}>
      <div className="page-width--slim">
        <div className={`padding-section-vertical ${include_divider ? 'border-bottom' : ""} ${styles.contentWrapper}`}>
          {isFilled.richText(subheading.richText) && (
            <motion.div
              className={styles.subHeadingContainer}
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.6, ease: [0.25, 0.1, 0.25, 1] }}
            >
              <PrismicRichText field={subheading.richText} components={{ heading3: ({ children }) => <p className="h3.5 text-left">{children}</p> }} />
            </motion.div>
          )}
          <motion.div
            className={styles.contentContainer}
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6, delay: 0.1, ease: [0.25, 0.1, 0.25, 1] }}
          >
            {isFilled.richText(heading.richText) && (
              <PrismicRichText field={heading.richText} components={{ heading2: ({ children }) => <h2 className={`h3 ${styles.heading} text-left`}>{children}</h2> }} />
            )}
            {text_content?.richText && (
              <PrismicRichText field={text_content.richText} />
            )}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export const query = graphql`
  fragment AboutPageDataBodyTextBlock on PrismicAboutPageDataBodyTextBlock {
    primary {
      heading {
        richText
        text
      }
      subheading {
        richText
        text
      }
      text_content {
        richText
        text
      }
      color_scheme
      include_divider
    }
  }
`;